import { env } from 'src/env.mjs';

const basePath = env.NEXT_PUBLIC_API_PATH;

export default {
    USER: (uuid: string) => `${basePath}/api/v2/users/${uuid}`,
};
